module.exports = __webpack_public_path__ + "static/media/new_cat_super_pack_EN_285x350.b4f947e6.png";